module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'loadingIndicator': _vm.loadingIndicator,
      'hasSOTW': _vm.hasSOTW
    }
  }, [(_vm.offline) ? _c('div', {
    staticClass: "ui floating warning message",
    staticStyle: {
      "opacity": ".8",
      "position": "fixed",
      "top": "0",
      "left": "20px",
      "z-index": "111"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('You seem to be offline')))]) : _vm._e(), _vm._v(" "), (_vm.$root.authCompleted) ? _c('model-sellers', {
    ref: "modelSellers"
  }) : _vm._e(), _vm._v(" "), (_vm.showFirstRunSyncModal) ? _c('first-run-sync-modal', {
    attrs: {
      "user-email": _vm.$root.userEmail,
      "onboarding-status": _vm.onboardingStatus,
      "on-dismiss": _vm.onFirstRunSyncDismiss
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": _vm.transitionMode
    }
  }, [_c('router-view', {
    on: {
      "sellerAccountsUpdated": function($event) {
        return _vm.$refs.modelSellers.updateSellers()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "stts21kdfslds"
  }), _vm._v(" "), _c('product-details-chart-modal', {
    ref: "chartModal"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "errorModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm._f("translate")('Error')))]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v(_vm._s(_vm._f("translate")('Close')))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "loginModal"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Log-in")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [(_vm.loginError) ? _c('div', {
    staticClass: "ui error message"
  }, [_c('div', [_vm._v(_vm._s(_vm.loginError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v(_vm._s(_vm._f("translate")('Email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "required": "true",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v(_vm._s(_vm._f("translate")('Password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "autofocus": "true",
      "required": "true"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keepMeSignedIn),
      expression: "keepMeSignedIn"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.keepMeSignedIn) ? _vm._i(_vm.keepMeSignedIn, null) > -1 : (_vm.keepMeSignedIn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.keepMeSignedIn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.keepMeSignedIn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.keepMeSignedIn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.keepMeSignedIn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("translate")('Keep me signed in')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui primary ok button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('Log in')))])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.announcement != null && _vm.announcement != _vm.closedAnnouncementText),
      expression: "announcement!=null&&announcement!=closedAnnouncementText"
    }],
    staticClass: "ui orange message SKannouncement"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.closedAnnouncementText = _vm.announcement
      }
    }
  }), _vm._v(" "), _c('strong', [_vm._v("[Announcement]")]), _vm._v("      " + _vm._s(_vm.announcement) + "\n    ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountErrors != null && !_vm.accountErrorsTextClosed),
      expression: "accountErrors!=null&&!accountErrorsTextClosed"
    }],
    staticClass: "ui red message SKannouncement"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.accErrorBoxClose
    }
  }), _vm._v(" "), _c('strong', [_vm._v("[IMPORTANT]")]), _vm._v("      " + _vm._s(_vm.accountErrors) + "\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "manyAsinsModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Light UI (beta) available")]), _vm._v(" "), _c('div', {
    staticClass: "ui content"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Lot's of products to show. You might benefit from our new Light UI. Simpler, snappier."), _c('br'), _vm._v("And you can always switch back just by reloading the page.")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui grey deny button"
  }, [_vm._v("No, Continue")]), _vm._v(" "), _c('div', {
    staticClass: "ui positive button"
  }, [_vm._v("Try out Light UI")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-380fcd77!./~/vue-loader/lib/selector.js?type=template&index=0!./src/IndexPage.vue
// module id = 748
// module chunks = 2